<div class="loading" id="loading">
  <div class="loading_img">
    <img src="/assets/img/icon-white/Loading screen clean.svg" alt="loading-img">
  </div>
  <div class="loading_spinner">
    <mat-spinner></mat-spinner>
  </div>
</div>